<template>
  <ui-radio-group
    :model-value="modelValue || GENDER_ALL"
    :disabled="disabled"
    class="flex flex-wrap gap-2.5"
    @update:model-value="(value) => $emit('update:modelValue', value)"
  >
    <label
      v-for="option in GENDERS"
      :key="option.value"
      :class="[ 'flex items-center gap-2 text-sm text-foreground', disabled ? 'cursor-not-allowed' : 'cursor-pointer' ]"
    >
      <ui-radio-group-item :value="option.value" />
      {{ tr(option.label) }}
    </label>
  </ui-radio-group>
</template>

<script>
import { GENDERS, GENDER_ALL } from '@/consts';

/** Gender targeting radio group; an empty value shows (and means) "All". */
export default {
  name: 'GenderSelector',
  props: {
    modelValue: {
      type: [ String, null ],
      required: false,
      default: () => null,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  emits: [ 'update:modelValue' ],
  data: () => ({
    GENDERS,
    GENDER_ALL,
  }),
};
</script>
